import { useState } from 'react';
import type { ResponseObject } from '../data/models';

export const useCheckbox = () => {
    const [checkedItems, setCheckedItems] = useState<Array<ResponseObject['externalProjectId']> | null>(null);

    const handleCheckItems = (id: ResponseObject['externalProjectId']) => {
        setCheckedItems(prevState => {
            if (prevState && id) {
                return [...prevState, id];
            }

            return [id];
        });
    };

    const handleUncheckItems = (id: ResponseObject['externalProjectId']) => {
        setCheckedItems(prevState => {
            if (prevState) {
                return prevState?.filter(item => item !== id);
            }

            return null;
        });
    };

    return {
        setCheckedItems,
        checkedItems,
        handleCheckItems,
        handleUncheckItems,
    };
};
